// extracted by mini-css-extract-plugin
export default {"data-table-container":"styles__data-table-container--nBdt1","spinner":"styles__spinner--H3Z2N"};